<template>
  <a
    :href="link"
    :target="target"
    class="button"
    :class="[
      `button--${skin}`,
      `button--${size}`,
      isDisabled && 'button--disabled',
      isRounded && 'button--rounded',
    ]"
    :style="[
      background && `background: var(--${background})`,
      color && `color: var(--${color})`,
    ]"
  >
    <slot />
  </a>
</template>

<script lang="ts">
export default {
  name: 'ButtonSimple',

  props: {
    size: {
      type: String,
      required: false,
      default: 'monithei',
    },
    skin: {
      type: String,
      required: false,
      default: 'primary',
    },
    background: {
      type: [String, null],
      required: false,
      default: null,
    },
    color: {
      type: [String, null],
      required: false,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    link: {
      type: String,
      required: false,
      default: '#',
    },
    target: {
      type: String,
      required: false,
      default: '_blank',
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "~/src/assets/stylus/main.styl";

$name = '.button'

{$name}--primary
  @extend $button--primary

{$name}--light
  @extend $button--light

{$name}
  @extend $button
  display inline-block
  transition background $effects.duration

  &--disabled
    @extend $button--disabled

  &--larishae
    width 40px
    height 40px
    min-width 40px
    padding 10px
    $border-radius("bana")

  &--monithei
    width 32px
    height 32px
    min-width 32px
    padding 8px
    $border-radius("theku")

  &--spelino
    padding 4px
    $border-radius("rajol")

  &--rounded
    border-radius 50%
</style>
